import { Values } from './type-utils';

export const TokenServices = {
  AccountManagementAutoGraderProd: 'accountManagementAutoGraderProd',
  AccountManagementAutomationStg: 'accountManagementAutomationStg',
  AccountManagementAutomationLabs1Prod: 'accountManagementAutomationProd',
  AccountManagementAutomationLabs2Prod: 'accountManagementAutomationLabs2Prod',
  AccountManagementAutomationCertificationsProd: 'accountManagementAutomationCertificationsProd',
  AccountManagementAutomationPartnerProd: 'accountManagementAutomationPartnerProd',
  AccountManagementMonitoringProd: 'accountManagementMonitoringProd',
  AdaAutomationStg: 'adaAutomationStg',
  AdaAutomationProd: 'adaAutomationProd',
  Docebo1: 'docebo1',
  Docebo2: 'docebo2',
  Docebo3: 'docebo3',
  Docebo4: 'docebo4',
  Docebo5: 'docebo5',
  Docebo6: 'docebo6',
  Docebo7: 'docebo7',
  Docebo8: 'docebo8',
  Docebo9: 'docebo9',
  Docebo10: 'docebo10',
  Docebo11: 'docebo11',
  Docebo12: 'docebo12',
  Docebo13: 'docebo13',
  Docebo14: 'docebo14',
  Docebo15: 'docebo15',
  DoceboAutomation1: 'doceboAutomation1',
  DoceboAutomation2: 'doceboAutomation2',
  DoceboAutomation3: 'doceboAutomation3',
  DoceboAutomation4: 'doceboAutomation4',
  DoceboAutomation5: 'doceboAutomation5',
  DoceboAutomation6: 'doceboAutomation6',
  DoceboAutomation7: 'doceboAutomation7',
  DoceboAutomation8: 'doceboAutomation8',
  DoceboAutomation9: 'doceboAutomation9',
  DoceboAutomation10: 'doceboAutomation10',
  DoceboAutomation11: 'doceboAutomation11',
  DoceboAutomation12: 'doceboAutomation12',
  DoceboAutomation13: 'doceboAutomation13',
  DoceboAutomation14: 'doceboAutomation14',
  DoceboAutomation15: 'doceboAutomation15',
  DoceboAutomation16: 'doceboAutomation16',
  DoceboAutomation17: 'doceboAutomation17',
  DoceboAutomation18: 'doceboAutomation18',
  DoceboAutomation19: 'doceboAutomation19',
  DoceboAutomation20: 'doceboAutomation20',
};
export type TokenServices = Values<typeof TokenServices>;

export enum TokenStage {
  Development = 'dev',
  Staging = 'stg',
  Production = 'prod',
}

export interface TokenCredentials {
  clientId: string;
  clientSecret: string;
  stage?: TokenStage;
  scopes?: string;
  resource?: string;
  password?: string;
  username?: string;
}

export interface TokenInfoList {
  [service: TokenServices]: TokenInfo | null;
}

export interface TokenInfo {
  token: string;
  expiresAt: string | Date;
  expiresIn?: number;
}

export interface TokenInfoWithExpiration extends TokenInfo {
  expiresIn: number;
}
